<template>
  <div class="Category flex-column h-full">
    <div class="page-title flex-fixed">{{ title }}</div>
    <div class="flex h-full">
      <div style="width:calc(100% - 280px);">
        <ATable
          ref="table"
          :placeholder="placeholder"
          :search_field="search_field"
          :data="items"
          :disable_insert="!has_grant_write"
          highlight-current-row
          border
          hide-pagination
          @cell-click="handleCellClick"
          @clicked-create="handleClickedCreate"
        >
          <el-table-column
            type="index"
            label="No"
            align="center"
            prop="index"
            :width="$width.index"
            :index="handleIndex"
          />
          <el-table-column label="이름" prop="name" width="100">
            <template slot-scope="scope">
              <el-input
                size="mini"
                maxlength="5"
                :readonly="scope.row.id !== editingId"
                v-bind:class="{
                  'readonly-noborder': scope.row.id !== editingId,
                }"
                v-model="scope.row.name"
              />
            </template>
          </el-table-column>
          <el-table-column label="비고" prop="desc">
            <template slot-scope="scope">
              <el-input
                size="mini"
                :readonly="scope.row.id !== editingId"
                v-bind:class="{
                  'readonly-noborder': scope.row.id !== editingId,
                }"
                v-model="scope.row.desc"
              />
            </template>
          </el-table-column>
          <el-table-column label="명령" width="150">
            <template slot-scope="scope">
              <div v-show="scope.row.id === editingId">
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="!has_grant_write"
                  :loading="load_button"
                  @click="handleClickRegister(scope.row)"
                  >저장</el-button
                >
                <el-button size="mini" @click="calcelEditing(scope.row)"
                  >취소</el-button
                >
              </div>
              <div v-show="scope.row.id !== editingId">
                <el-button
                  size="mini"
                  :disabled="!has_grant_write"
                  @click="handleClickModify(scope.row)"
                  >수정</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  :disabled="!has_grant_write"
                  :loading="load_button"
                  @click="handleClickDelete(scope.row)"
                  >삭제</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_user_name"
            :label="$t('lang.created_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="modified_user_name"
            :label="$t('lang.modified_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="created_at"
            :label="$t('lang.created_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <el-table-column
            prop="modified_at"
            :label="$t('lang.modified_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
        </ATable>
      </div>
      <el-divider direction="vertical" class="h-full"></el-divider>
      <div class="flex-fixed pl-default" style="width: 250px">
        <el-card class="box-card" v-if="selectedItem">
          <div slot="header" class="clearfix">
            <span>{{ selectedName }} 코드(우편번호앞 3자리)</span>
          </div>
          <el-input type="textarea" :rows="30" v-model="details"> </el-input>
          <el-button
            size="mini"
            type="primary"
            class="mt-default"
            @click="handleClickUpdate()"
            >등록</el-button
          >
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";

export default {
  name: "Category",
  mixins: [form_container, authority_level],
  data() {
    return {
      title: this.$t("title.area"),
      loading: false,
      placeholder: "이름, 비고",
      search_field: ["name", "desc"],
      items: [],
      editingId: -1,
      oldItem: undefined,
      selectedItem: undefined,
      deleteItem: undefined,
      details: "",
      load_button: false,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    selectedName() {
      return this.selectedItem ? this.selectedItem.name : "";
    },
    has_grant_write() {
      return this.isWriteLevel("area");
    },
  },
  methods: {
    loadData() {
      this.selectedItem = null;
      this.api.listArea().then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteArea(this.deleteItem).then((res) => {
        this.load_button = false;
        this.handleResponse(res, this.$t("message.success_delete"));
      });
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.selectedItem = item;
      this.api.listDetailArea(this.selectedItem).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        let details = "";
        res.data.forEach((code) => {
          if (details.length > 0) {
            details += "\n";
          }
          details += code.code;
        });
        this.details = details;
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.selectedItem = null;
      this.editingId = 0;
      this.oldItem = { id: 0, name: "", desc: null };
      this.items.push(this.oldItem);
    },
    handleClickRegister(data) {
      let isDuplicated = false;
      data.name = data.name.trim();
      if (data.name.length < 1) {
        this.util.notify_warning(this, this.title, "이름을 입력해주세요.");
        return;
      }
      this.items.forEach((item) => {
        if (item.id !== data.id && item.name === data.name) {
          isDuplicated = true;
        }
      });
      if (isDuplicated) {
        this.util.notify_warning(this, this.title, "중복된 이름입니다.");
        return;
      }
      this.load_button = true;
      if (data.id) {
        this.api.updateArea(data).then((res) => {
          this.load_button = false;
          this.handleResponse(res, this.$t("message.success_update"));
        });
      } else {
        this.api.createArea(data).then((res) => {
          this.load_button = false;
          this.handleResponse(res, this.$t("message.success_create"));
        });
      }
    },
    handleClickModify(data) {
      this.selectedItem = null;
      if (this.editingId === data.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = data.id;
      this.oldItem = Object.assign({}, data);
    },
    handleClickDelete(data) {
      this.deleteItem = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.name + "]",
        this.doDelete
      );
    },
    handleClickUpdate() {
      let data = { id: this.selectedItem.id };
      let details = this.details.split("\n");
      let hasError = false;
      details = details.filter((value) => value.trim().length > 0);
      details.forEach((code) => {
        if (hasError) {
          return false;
        }
        let val = code.trim();
        if (isNaN(val)) {
          this.util.notify_warning(this, this.title, "숫자만 입력 가능합니다.");
          hasError = true;
          return false;
        }
        if (val.length != 3) {
          this.util.notify_warning(this, this.title, "3자리만 입력해 주세요.");
          hasError = true;
          return false;
        }
      });
      if (!hasError) {
        // trim 제거, 중복코드 확인
        for (let i = 0; i < details.length; i++) {
          details[i] = details[i].trim();
          if (i + 1 < details.length) {
            for (let j = i + 1; j < details.length; j++) {
              if (details[i] === details[j].trim()) {
                this.util.notify_warning(
                  this,
                  this.title,
                  "동일 코드가 존재합니다."
                );
                hasError = true;
                return false;
              }
            }
          }
        }
      }
      if (hasError) {
        return;
      }
      let values = [];
      details.forEach((code) => {
        values.push({ code: code });
      });
      data.details = values;
      this.load_button = true;
      this.api.updateArea(data).then((res) => {
        this.load_button = false;
        this.handleResponse(res, this.$t("message.success_register"), false);
      });
    },
    handleResponse(res, successMessage, reload = true) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
      if (!reload) {
        return;
      }
      this.loadData();
    },
  },
};
</script>
